module.exports = __webpack_public_path__ + "img/banner_fr.8a64ff7b.png";